import React from "react";
import SectionMainTitle from "../components/SectionMainTitle";
import SectionRecommendations from "../components/SectionRecommendations";
import SectionWelcome from "../components/SectionWelcome";

export default function AdsLandingContent() {
  return (
    <>
      <SectionMainTitle />
      <SectionRecommendations />
      <SectionWelcome />
    </>
  );
}
